import { ClosingMethod as ClosingMethodGenerated } from 'generated-graphql/types';
import { ClosingMethod } from 'services/campaign/types';

export const convertToGeneratedClosingMethod = (
  method: ClosingMethod | undefined | null
): ClosingMethodGenerated | undefined | null => {
  switch (method) {
    case ClosingMethod.PHONE_NUMBER:
      return ClosingMethodGenerated.PhoneNumber;
    case ClosingMethod.MEETING_URL:
      return ClosingMethodGenerated.MeetingUrl;
    case ClosingMethod.CALENDAR_MEETING_INTEGRATION:
      return ClosingMethodGenerated.CalendarMeetingIntegration;
    case ClosingMethod.CUSTOM:
      return ClosingMethodGenerated.Custom;
    default:
      return undefined;
  }
};
